module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-neutral-fill-5234fc6e.svg";